module.exports = __webpack_public_path__ + "static/img/动态皮带区域识别.40913f67.png";